import styled from 'styled-components';

interface IconButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  width?: string;
  height?: string;
}

function IconButton({ children, onClick, width, height }: IconButtonProps) {
  return (
    <StyledIconButton width={width} height={height} onClick={onClick}>
      {children}
    </StyledIconButton>
  );
}

export default IconButton;

const StyledIconButton = styled.button<{ width?: string; height?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: ${({ width }) => width ?? '50px'};
  height: ${({ height }) => height ?? '50px'};
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  transition: transform 0.1s ease-in-out;

  &:active {
    transform: scale(0.95);
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    color: white;
  }

  &:focus {
    outline: none;
  }
`;
